// API Configuration
const API_BASE_URL = 'https://capstone-2-b256-legaspina-ecommerce.vercel.app';

// API Endpoints
export const API_ENDPOINTS = {
  // User endpoints
  USERS: {
    LOGIN: `${API_BASE_URL}/users/login`,
    REGISTER: `${API_BASE_URL}/users/register`,
    CHECK_EMAIL: `${API_BASE_URL}/users/checkEmail`,
    USER_DETAILS: `${API_BASE_URL}/users/userDetails`,
  },
  
  // Product endpoints
  PRODUCTS: {
    ALL: `${API_BASE_URL}/products/all`,
    ACTIVE: `${API_BASE_URL}/products/active`, // Back to real products endpoint
    ADD: `${API_BASE_URL}/products/addProduct`,
    GET_BY_ID: (id) => `${API_BASE_URL}/products/${id}`,
    EDIT: (id) => `${API_BASE_URL}/products/edit/${id}`,
    ARCHIVE: (id) => `${API_BASE_URL}/products/${id}/archive`,
    ACTIVATE: (id) => `${API_BASE_URL}/products/${id}/activate`,
    DELETE: (id) => `${API_BASE_URL}/products/${id}`,
  },
  
  // Order endpoints
  ORDERS: {
    CHECKOUT: `${API_BASE_URL}/orders/checkout`,
    ALL: `${API_BASE_URL}/orders/all`,
    CART_ITEMS: `${API_BASE_URL}/orders/cartItems`,
    ADD_TO_CART: `${API_BASE_URL}/orders/addToCart`,
    REMOVE_FROM_CART: (id) => `${API_BASE_URL}/orders/cartItems/${id}`,
    ORDER_DETAILS: (userId) => `${API_BASE_URL}/orders/${userId}/orderDetails`,
  }
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Helper function for API calls
export const apiCall = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      headers: getAuthHeaders(),
      ...options,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export default API_BASE_URL;
